import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#050508" }}>
      {/* ===== FINAL CTA ===== */}
      <section
        data-testid="final-cta"
        className="relative py-24 md:py-32 overflow-hidden"
        style={{ backgroundColor: "#050508" }}
      >
        <img
          src="/assets/particle-lines.svg"
          alt=""
          aria-hidden="true"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "1200px",
            maxWidth: "100vw",
            height: "auto",
            opacity: 1,
            pointerEvents: "none",
            zIndex: 1,
          }}
        />

        <div className="relative z-10 max-w-4xl mx-auto text-center px-6">
          <h2
            className="text-2xl md:text-3xl lg:text-4xl font-medium leading-tight"
            style={{ fontFamily: "'Lora', serif", color: "#F5F5F5" }}
          >
            Experience the
            <br />
            Future of Wealth
          </h2>

          <div className="mt-6">
            <Link
              to="/contact"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 22px",
                borderRadius: "999px",
                border: "1px solid rgba(255,255,255,0.22)",
                background: "rgba(0,0,0,0.35)",
                color: "#F5F5F5",
                fontFamily: "'Lora', serif",
                fontSize: "10px",
                fontWeight: 500,
              }}
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>

      {/* ===== FOOTER INFO ROW ===== */}
      <section className="px-6 md:px-12 lg:px-24 pb-10">
        <div
          className="max-w-6xl mx-auto pt-10"
          style={{ borderTop: "1px solid rgba(255,255,255,0.10)" }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Column 1: Brand + Address */}
            <div>
              <div
                className="text-base mb-3"
                style={{
                  color: "#F5F5F5",
                  fontFamily: "'Lora', serif",
                  fontWeight: 600,
                }}
              >
                Compu.J
              </div>

              <div
                className="text-sm leading-relaxed"
                style={{ color: "#A1A1AA", fontFamily: "'Lora', serif" }}
              >
                Unit 4.01, The Tea Building
                <br />
                56 Shoreditch High Street
                <br />
                London, UK
                <br />
                E1 6JJ
              </div>
            </div>

            {/* Column 2: Links */}
            <div>
              <div
                className="text-sm mb-3"
                style={{
                  color: "#F5F5F5",
                  fontFamily: "'Lora', serif",
                  fontWeight: 600,
                }}
              >
                Pages
              </div>

              <ul
                className="space-y-2 text-sm"
                style={{ color: "#A1A1AA", fontFamily: "'Lora', serif" }}
              >
                <li>
                  <Link to="/platform" className="hover:underline">
                    Platform
                  </Link>
                </li>
                <li>
                  <Link to="/security" className="hover:underline">
                    Security
                  </Link>
                </li>
                <li>
                  <Link to="/case-studies" className="hover:underline">
                    Case Studies
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:underline">
                    About Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Contact + External */}
            <div>
              <div
                className="text-sm mb-3"
                style={{
                  color: "#F5F5F5",
                  fontFamily: "'Lora', serif",
                  fontWeight: 600,
                }}
              >
                Contact
              </div>

              <ul
                className="space-y-2 text-sm"
                style={{ color: "#A1A1AA", fontFamily: "'Lora', serif" }}
              >
                <li>
                  <a href="mailto:enquiries@compuj.com" className="hover:underline">
                    enquiries@compuj.com
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.linkedin.com/company/compu-j/?viewAsMember=true"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    LinkedIn
                  </a>
                </li>

                <li>
                  <a
                    href="https://compuj.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    Visit our main website
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom row */}
          <div
            className="mt-10 text-center text-xs"
            style={{ color: "#A1A1AA", fontFamily: "'Lora', serif" }}
          >
            © {new Date().getFullYear()} Compu.J. All rights reserved.
          </div>
        </div>
      </section>
    </footer>
  );
}